import React, { useCallback, useEffect, useState } from 'react';
import { HiCheck } from 'react-icons/hi';

import { Container, CheckboxInput, Error } from './styles';

export interface IOption {
  value: string | number;
  label: string;
  selected?: boolean;
}

interface IInputCheckbox {
  name: string;
  options: IOption[];
  className?: string;
  onChange?(options: IOption[]): void;
  error?: string;
}

const InputCheckbox: React.FC<IInputCheckbox> = ({
  name,
  options,
  className,
  onChange,
  error,
}) => {
  const [data, setData] = useState<IOption[]>([]);

  useEffect(() => {
    setData(options);
  }, [options]);

  const handleChange = useCallback(
    (option) => {
      const newData = data.slice();
      const dataIndex = newData.findIndex(
        (optionData) => optionData === option
      );
      if (dataIndex >= 0) {
        newData[dataIndex].selected = !newData[dataIndex].selected;
        setData(newData);
      }
      if (onChange) {
        onChange(newData);
      }
    },
    [data, onChange]
  );

  return (
    <>
      <Container className={className}>
        {options.map((option, index) => (
          <CheckboxInput
            htmlFor={`${name}_${index}`}
            selected={option.selected}
          >
            <div>{option.selected && <HiCheck size={12} color="#fff" />}</div>
            <input
              type="checkbox"
              id={`${name}_${index}`}
              name={`${name}_checkbox`}
              value={option.value}
              onChange={() => handleChange(option)}
              className="inputData"
            />
            <span>{option.label}</span>
          </CheckboxInput>
        ))}
      </Container>
      {error && <Error className="small text-danger error">{error}</Error>}
    </>
  );
};

export default InputCheckbox;
